export default function valueInUSD(value, exchangeRate) {
    if (value) {
        return value / exchangeRate;
    }
    return value;
}